var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { DRIVE_ACTIONS_OVER_TIME_KEYS, emptyDriveActionsOverTimeCounts } from '@workalizer/shared';
import { calculateAverage, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod, randomInt } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var generateMockCounts = function () { return ({
    created: randomInt(5, 40),
    edited: randomInt(30, 120),
    viewed: randomInt(80, 200),
    commentsPosted: randomInt(10, 60),
    suggestionsPosted: randomInt(5, 35),
    otherEvents: randomInt(20, 80)
}); };
var TEAM_USER_COUNT = 8;
export var driveActionsOverTime = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periods, previousPeriods);
    var periodsData = periods.map(function (period, idx) {
        var _a;
        var currentData = generateMockCounts();
        var prevPeriod = periodMatcher.getItem(idx, previousPeriods);
        var prevData = generateMockCounts();
        return __assign(__assign({ period: period.date, previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '' }, currentData), { prevCreated: prevData.created, prevEdited: prevData.edited, prevViewed: prevData.viewed, prevCommentsPosted: prevData.commentsPosted, prevSuggestionsPosted: prevData.suggestionsPosted, prevOtherEvents: prevData.otherEvents, teamCreated: input.userId ? Math.round(currentData.created * 0.85) : 0, teamEdited: input.userId ? Math.round(currentData.edited * 0.85) : 0, teamViewed: input.userId ? Math.round(currentData.viewed * 0.9) : 0, teamCommentsPosted: input.userId
                ? Math.round(currentData.commentsPosted * 0.8)
                : 0, teamSuggestionsPosted: input.userId
                ? Math.round(currentData.suggestionsPosted * 0.75)
                : 0, teamOtherEvents: input.userId
                ? Math.round(currentData.otherEvents * 0.8)
                : 0 });
    });
    var currentTotals = periodsData.reduce(function (acc, period) {
        for (var _i = 0, DRIVE_ACTIONS_OVER_TIME_KEYS_1 = DRIVE_ACTIONS_OVER_TIME_KEYS; _i < DRIVE_ACTIONS_OVER_TIME_KEYS_1.length; _i++) {
            var key = DRIVE_ACTIONS_OVER_TIME_KEYS_1[_i];
            acc[key] += period[key];
        }
        return acc;
    }, emptyDriveActionsOverTimeCounts());
    var prevTotals = periodsData.reduce(function (acc, period) {
        acc.created += period.prevCreated;
        acc.edited += period.prevEdited;
        acc.viewed += period.prevViewed;
        acc.commentsPosted += period.prevCommentsPosted;
        acc.suggestionsPosted += period.prevSuggestionsPosted;
        acc.otherEvents += period.prevOtherEvents;
        return acc;
    }, emptyDriveActionsOverTimeCounts());
    return {
        periods: periodsData,
        totals: Object.fromEntries(DRIVE_ACTIONS_OVER_TIME_KEYS.map(function (key) { return [
            key,
            __assign({ current: currentTotals[key], previous: getPercentageDiff(prevTotals[key], currentTotals[key]) }, (input.userId && {
                teamAverage: getPercentageDiff(calculateAverage(Math.round(currentTotals[key] * TEAM_USER_COUNT * 0.88), TEAM_USER_COUNT), currentTotals[key])
            }))
        ]; }))
    };
};
